import { render, staticRenderFns } from "./Lager.vue?vue&type=template&id=1a39adde&"
import script from "./Lager.vue?vue&type=script&lang=js&"
export * from "./Lager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports